import React, {FC} from 'react';

import {Cards} from './Cards/Cards';
import {Contacts} from './Contacts/Contacts';
import {Instruction} from './Instruction/Instruction';
import {Reviews} from './Reviews/Reviews';

const Index: FC = () => (
    <>
        <div className={'content'}>
            <Cards/>
            <Instruction/>
            <Reviews/>
        </div>
        <div className={'content'}>
            <Contacts/>
        </div>
    </>
    );

export default Index;



